import React from 'react'
import { AthleteJersey } from '../../common/Graphics'

const PlayerOfTheMatch = ({
  pom = [],
  isMedium = false
}) => {
  let singleOrDoubleClass = 'gp__cricket__player-match__player gp__cricket__player-match__player--'
  let singlePlayer =  false
  if (pom && pom.length === 1) {
    singleOrDoubleClass = singleOrDoubleClass +'single'
    singlePlayer = true
  }else if(pom && pom.length === 2) {
    singleOrDoubleClass = singleOrDoubleClass +'double'
  }
  const content = (
	<div className="gp__cricket__player-match">
		<div className="gp__cricket__player-match__title">Player{pom.length >1 ? 's' :''} of the Match</div>
		<div className="gp__cricket__playerDetails">
      <div className={singleOrDoubleClass}>
      {
        pom && pom.map((m = {}, i) => {
          return [ 
            singlePlayer && m.headshot && !/default-player-logo/.test(m.headshot) ?
            <a name={m.trackingName} href={m.href} className="gp__cricket__player-match__player__headshot headshot-lg athlete" dangerouslySetInnerHTML={{ __html: `<img data-src="${m.headshot}" class="lazyload"/>` }} /> 
            : singlePlayer && <AthleteJersey trackingName={m.trackingName} href={m.href} isMedium={isMedium} /> 
          ,
            <div key={i} className="gp__cricket__player-match__player__detail">
              <a name={m.trackingName} href={m.href} className="gp__cricket__player-match__player__detail__link" dangerouslySetInnerHTML={{ __html: `${m.name}<span>${m.team}</span>` }} />
            </div>
          ]
        })
      }
      </div>
		</div>
	</div>
)
  return pom.length ? content : <div className="gp__cricket__player-match" />
}

export default PlayerOfTheMatch



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/cricket/PlayerOfTheMatch.jsx
 **/